import React, {useEffect, useState} from 'react';
import { ptBR } from "date-fns/locale";
import { Link } from "react-router-dom";
import { ArrowUpRightIcon } from '@heroicons/react/24/outline';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import ReactPaginate from 'react-paginate';

import {
  Button,
  Card,
  Divider,
  Dropdown,
  DropdownItem,
  Grid,
  Col,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
  Title,
  TextInput,
  DateRangePicker,
  DateRangePickerValue,
  Toggle,
  ToggleItem,
  Tab,
  TabList
} from '@tremor/react';

import SidebarComponent from '../components/SidebarComponent';
import TitleComponent from '../components/TitleComponent';
import CorreiosSearchComponent from '../components/searchComponents/CorreiosSearchComponent';
import './SearchPage.css';

import { Drivers, Organization, User } from '../interfaces/AccessInterfaces';
import { OrderSources, ShortOrder } from '../interfaces/OrderInterfaces';
import { meliSubStatusTranslate, shopeeLogisticStatusTranslate, statusChannelTranslate } from '../utils/translates'
import { convertDate, convertDateBr } from '../utils/convertDate';

import { getTransporterClients } from '../api/index';

export default function SearchPage(
  {drivers, selectedOrders, setSelectedOrders}:{drivers:Drivers, selectedOrders:string[], setSelectedOrders:Function}
) {
  const [cookies] = useCookies(['mazelog-user']);
  const token = cookies['mazelog-user']?.token_data?.access_token;
  const userProfile = cookies['mazelog-user']?.user_data?.user_profile;
  const isTransporter = userProfile === "TRANSPORTER" || userProfile === "TRANSPORTER_COLLECTER"
  const isClient = userProfile === "CLIENT"
  const isAdmin = userProfile === "ADMIN" || userProfile === "CORP" ;
  const orgId = cookies["mazelog-user"]?.organization_data?.id_org;

  const oauth = "Bearer " + token;

  const [showCard, setShowCard] = useState("0");

  const statusTranslate: { [key: string]: string } = {
    "created": "Criado",
    "transporter_allocated": "Transportador alocado",
    "collected": "Coletado",
    "received": "Recebido",
    "en_route": "Em rota",
    "delivered": "Entregue",
    "cancelled": "Cancelado",
    "handling": "Em tratativa",
    "awaiting_return": "Aguard. devolução",
    "awaiting_transfer": "Aguard. transferência",
    "return_route": "Rota devolução",
    "returned": "Devolvido",
    "collected_not_received": "Coletados Não Receb.",
    "cancelled_after_received": "Canc. após Receb.",
    "returned_area_not_serviced": "Devolvido - Área não atendida",
    "new_driver_allocated": "Novo entregador alocado"
}

  const now = new Date();

  const [requested, setRequested] = useState<boolean>(false);

  const [searchedOrders, setSearchedOrders] = useState<ShortOrder[]>([]);
  const [totalInternal, setTotalInternal] = useState<number>(0);
  const [totalMeli, setTotalMeli] = useState<number>(0);
  const [totalShopee, setTotalShopee] = useState<number>(0);
  const [totalUnk, setTotalUnk] = useState<number>(0);

  // const [searchedOrdersFiltered, setSearchedOrdersFiltered] = useState<ShortOrder[]>([]);
  const [selectedNumber, setSelectedNumber] = useState<string>('');
  const [selectedReceipt, setSelectedReceipt] = useState<string>('');
  const [selectedStatus, setSelectedStatus] = useState<string>('all');
  const [selectedSender, setSelectedSender] = useState<string>('');
  const [selectedReceiver, setSelectedReceiver] = useState<string>('');
  const [selectedTransporter, setSelectedTransporter] = useState<string>('all');
  const [selectedSource, setSelectedSource] = useState<string>('all');
  const [selectedDriver, setSelectedDriver] = useState<number>();
  const [wrongDriverId, setWrongDriverId] = useState<boolean>(false);
  const [selectedDateRange, setSelectedDateRange] = useState<DateRangePickerValue>([
    new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1),
    now
  ]);
  const [page, setPage] = useState<number>(0);
  const [fileDownloadLoading, setFileDownloadLoading] = useState<boolean>(false);
  const [filterByDate, setFilterByDate] = useState<string>("emission");
  const [statusChannel, setStatusChannel] = useState<string>('all');

  const [transporterClients, setTransporterClients] = useState<Organization[]>([]);
  const [selectedTransporterClients, setSelectedTransporterClients] = useState<string>('-1');

  const [selectedUser, setSelectedUser] = useState<string>("");
  const [users, setUsers] = useState<User[]>([]);
  
  const baseURL = process.env.REACT_APP_MAZELOG_SYSTEM_BASE_URL;

  const handleSubmit = async (pageSelected: number = 0) => {
    setRequested(true);
    
    try {
        let URL = `${baseURL}/order/query?${filterByDate}_start_date=${selectedDateRange[0]?.toISOString()}&${filterByDate}_end_date=${selectedDateRange[1]?.toISOString()}`;
        
        if (selectedNumber !== '') URL = `${baseURL}/order/query?order_number=${selectedNumber}`;
        else {
          if (selectedReceipt !== '') URL += `&receipt_number=${selectedReceipt}`;
          if (selectedStatus !== 'all') URL += `&status=${selectedStatus}`;
          if (selectedSender !== '') URL += `&sender_document=${selectedSender}`;
          if (selectedReceiver !== '') URL += `&receiver_document=${selectedReceiver}`;
          if (selectedTransporter !== 'all') URL += `&transporter=${selectedTransporter}`;
          if (selectedSource !== 'all') URL += `&source=${selectedSource}`;
          if (selectedDriver) URL += `&courier_id_user=${selectedDriver}`;
          if (selectedUser) URL += `&courier_id_user=${selectedUser}`;
          if (selectedTransporterClients !== '-1') URL += `&created_by_id_org=${selectedTransporterClients}`;
          if (statusChannel !== 'all') {
              const [status, subStatus] = statusChannel.split("|");
              URL += `&meli_status=${status}`;
              if (subStatus) {
                  URL += `&meli_substatus=${subStatus}`;
              }
          }
        }
        URL += `&page=${pageSelected}`;

        const res = await axios.get(URL, {
            headers: { accept: 'application/json', "Authorization": oauth }
        });

        console.log(res);

        setSearchedOrders(res.data.results);
        setTotalInternal(res.data.total_internal);
        setTotalMeli(res.data.total_meli);
        setTotalShopee(res.data.total_shopee);
        setTotalUnk(res.data.total_unk);
        
        // return res.data.length;
    } catch (err) {
        console.log(err);
    } finally {
        setRequested(false);
    }
};

  const handleBatchDelete = () => {
    let confirmation = prompt("Se deseja mesmo apagar todos esses pedidos, digite: MAZELOG_E_O_MELHOR");
    if (confirmation === "MAZELOG_E_O_MELHOR") {
      axios.post(`${baseURL}/order/batch/delete`,
      {data: selectedOrders},
      {headers: {accept: 'application/json', "Authorization": oauth}})
      .then((res)=>{
        window.alert("Pedidos apagados com sucesso");
        handleSubmit();
      })
      .catch((err)=>{
        console.log(err);
      })
    } else {
      window.alert("Operação de apagar cancelada");
    }
  }

  const handleFilter = async () => {
    setTotalInternal(0);
    setTotalMeli(0);
    await handleSubmit()
    setPage(0);
  }

  const truncateString = (text:string, maxLength: number):string => {
    if (text.length <= maxLength) {
      return text
    } else {
      return text.substring(0, maxLength) + '...'
    }
  }

  const driverFilterHandler = (email: string) => {
    const id_user = Object.keys(drivers).find((key:any) => drivers[key].email === email);
    if (id_user) {
      setWrongDriverId(false);
      setSelectedDriver(parseInt(id_user));
    } else {
      setSelectedDriver(undefined);
      setWrongDriverId(true);
    }
  }

  const buildOrderExcel = async () : Promise<Blob> => {
    let URL = `${baseURL}/order/query/file/v2?${filterByDate}_start_date=${selectedDateRange[0]?.toISOString()}&${filterByDate}_end_date=${selectedDateRange[1]?.toISOString()}`
    if(selectedNumber !== ''){URL += `&order_number=${selectedNumber}`}
    if(selectedReceipt !== ''){URL += `&receipt_number=${selectedReceipt}`}
    if(selectedStatus !== 'all'){URL += `&status=${selectedStatus}`}
    if(selectedReceiver !== ''){URL += `&receiver_document=${selectedReceiver.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()\s]/g,"")}`}
    if(selectedDriver){URL += `&courier_id_user=${selectedDriver}`}
    const resp = await axios.get(URL,{
      headers: {accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', "Authorization": oauth},
      responseType: 'blob'
    })
    return resp.data
  }

  const downloadCsv = async () => {
    setFileDownloadLoading(true);
    try {
      const excelBlob = await buildOrderExcel();
      console.log(excelBlob);
      const url = window.URL.createObjectURL(excelBlob);
      const a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", "pedidos.xlsx");
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao baixar arquivo:', error);
    } finally {
      setFileDownloadLoading(false);
    }
  }

  const checkOneHandler = (orderNumber: string) => {
    if (selectedOrders.includes(orderNumber)) {
      setSelectedOrders(selectedOrders.filter((value)=>{
            return value !== orderNumber
        }))
    } else {
        const updatedSelectedOrders = selectedOrders.concat(orderNumber);
        setSelectedOrders(updatedSelectedOrders);
    }
  }

  const checkAllHandler = () => {
    if (searchedOrders.length === selectedOrders.length) {
      setSelectedOrders([])
    } else {
      const orderNumbers = searchedOrders.map(({orderNumber}) => orderNumber);
      setSelectedOrders(orderNumbers);
    }
  }

  const calculatePageCount = () => {
    let page_size = 50;
    return Math.ceil( Math.max(totalInternal, totalMeli, totalShopee, totalUnk) / page_size);
  };

  // filter in front if need
  // useEffect(() => {
  //   setSearchedOrdersFiltered(searchedOrders.filter(x=> 
  //     ( x.statusChannel?.type === statusChannel || statusChannel === 'all' )
  //   ));
  // },[searchedOrders, statusChannel])

  const loadTransporterClients = async () => {
    const transporterUserName = cookies['mazelog-user']?.organization_data?.name || '';
    if (transporterUserName && isTransporter) {
      const res = await getTransporterClients(oauth, transporterUserName);
      res.unshift({
        id_org: -1, name: "Todos os clientes",
        cnpj: '',
        prefix: '',
        profile: '',
        product_flag: false,
        whatsapp_flag: false,
        email_flag: false,
        spreadsheet: false,
        correios: false,
        flag_router: false
      });
      setTransporterClients(res);
    } 
  }

  
    const getUsers = () => {
      const baseURL = process.env.REACT_APP_MAZELOG_AUTH_BASE_URL;
      const oauth = "Bearer " + token;
  
      let url = `${baseURL}/users`;
      if (isTransporter) {
        url = `${baseURL}/users/company/${orgId}`;
      }
  
      axios.get(url,
        {headers: {accept: 'application/json', "Authorization": oauth}}
      )
      .then((res)=>{
        console.log(res);
        setUsers(res.data.data);
      })
      .catch((err)=>{
        console.log(err);
      })
    }
  

  useEffect(() => {
    // if (!requested) handleSubmit();
    getUsers();
    loadTransporterClients();
  }, []); 

  return (
    <main className="Page">
      <SidebarComponent />
      <div className="Content">
        <TitleComponent />
          <div className="flex flex-col p-8">
            <TabList
              defaultValue="0"
              onValueChange={(value) => setShowCard(value)}
              className='mb-4'
            >
              <Tab value="0" text="Envio Mazelog" className={showCard === "0" ? 'SelectedTab' : 'OtherTab'}/>
              {!isTransporter ? (
                <Tab value="1" text="Correios" className={showCard === "1" ? 'SelectedTab' : 'OtherTab'}/>
              ) : <></>}
            </TabList>

          {/* Search Component */}
          {showCard === "0" ? (
            <div className=''>
            <Card>
                <Grid numCols={2} className="gap-2">
                  <Col numColSpan={1}>
                    <Title>ID do pedido</Title>
                    <TextInput className='max-w-md' onChange={(e) => setSelectedNumber(e.target.value)}/>
                  </Col>
                  <Col numColSpan={1}>
                    <Title>Número da nota</Title>
                    <TextInput
                      placeholder='0000000000'
                      className='max-w-md'
                      onChange={(e) => setSelectedReceipt(e.target.value)}
                    />
                  </Col>
                  { !isTransporter && (
                    <Col numColSpan={1}>
                      <Title>CNPJ remetente</Title>
                      <TextInput placeholder="00.000.000/0000-00" className='max-w-md' onChange={(e) => setSelectedSender(e.target.value)}/>
                    </Col>
                  )}
                  <Col numColSpan={1}>
                    <Title>CNPJ/CPF destinatário</Title>
                    <TextInput placeholder="00.000.000/0000-00" className='max-w-md' onChange={(e) => setSelectedReceiver(e.target.value)}/>                  
                  </Col>
                  {(!isClient) && (
                    // <Col numColSpan={1}>
                    //   <Title>Email entregador</Title>
                    //   <TextInput className='max-w-md' error={wrongDriverId} onChange={(e) => driverFilterHandler(e.target.value)}/>
                    // </Col>
                    <Col numColSpan={1}>
                        <Title>Motorista</Title>
                        <div className="flex items-center justify-between">
                            <Dropdown
                                className="max-w-md"
                                value={selectedUser}
                                onValueChange={(value) => setSelectedUser(value)}
                                placeholder="Selecione um usuário"
                                >
                                {[
                                    <DropdownItem key="none" value="" text="Nenhum" />,
                                    ...users
                                    .filter(x => x.user_profile === "TRANSPORTER" || x.user_profile === "TRANSPORTER_COLLECTER")
                                    .map((item) => (
                                        <DropdownItem
                                        key={item.id_user}
                                        value={item.id_user?.toString() ?? ""}
                                        text={item.email}
                                        />
                                    )),
                                ]}
                            </Dropdown>
                        </div>
                    </Col>
                  )}
                  {(!isTransporter && !isClient) && (
                    <Col numColSpan={1}>
                      <Title>Transportadora</Title>
                      <Dropdown
                        className="max-w-md"
                        defaultValue="all"
                        onValueChange={(value) => setSelectedTransporter(value)}
                      >
                        <DropdownItem value="all" text="Todas as transportadoras" />
                        <DropdownItem value="none" text="N/A" />
                        <DropdownItem value="flashExpress" text="Flash Express" />
                        <DropdownItem value="arrFlex" text="ARR Flex" />
                      </Dropdown>
                    </Col>
                  )}
                  { isTransporter && (
                    <Col numColSpan={1}>
                      <Title>Cliente</Title>
                      <Dropdown
                        className="max-w-md"
                        defaultValue="-1"
                        onValueChange={(value) => setSelectedTransporterClients(value)}
                      >
                          {transporterClients.map((client) => (
                            <DropdownItem value={String(client.id_org)} text={client.name} />
                          ))}
                      </Dropdown>
                    </Col>
                  )}
                  <Col numColSpan={1}>
                    <Title>Canal</Title>
                    <Dropdown
                        className='max-w-md'
                        defaultValue="all"
                        onValueChange={(value) => { setSelectedSource(value); setStatusChannel("all"); }}
                    >
                        <DropdownItem value="all" text="Todos os canais" />
                        <DropdownItem value="mazelog" text="Mazelog" />
                        <DropdownItem value="mercado_livre" text="Mercado Livre" />
                        <DropdownItem value="shopee" text="Shopee" />
                        <DropdownItem value="unknown" text="Avulso" />
                    </Dropdown>
                  </Col>
                  <Col numColSpan={1}>
                  <Title>Data de {filterByDate === "emission" ? "criação" : "atualização"}</Title>
                    <DateRangePicker
                      className="max-w-md"
                      value={selectedDateRange}
                      onValueChange={setSelectedDateRange}
                      locale={ptBR}
                      dropdownPlaceholder="Selecionar"
                      enableYearPagination={true}
                    />
                  </Col>
                  <Col numColSpan={1}>
                  <Title>Status MZO</Title>
                  <Dropdown
                        className='max-w-md'
                        defaultValue="all"
                        onValueChange={ (value) => setSelectedStatus(value) }
                    >
                        <DropdownItem value="all" text="Todos os status" />
                        <DropdownItem value="created" text="Criado" />
                        <DropdownItem value="transporter_allocated" text="Transportador alocado" />
                        <DropdownItem value="collected" text="Coletado" />
                        <DropdownItem value="received" text="Recebido" />
                        <DropdownItem value="en_route" text="Em rota" />
                        <DropdownItem value="delivered" text="Entregue" />
                        <DropdownItem value="cancelled" text="Cancelado" />
                        <DropdownItem value="handling" text="Em tratativa" />
                        <DropdownItem value="awaiting_return" text="Aguard. devolução" />
                        <DropdownItem value="awaiting_transfer" text="Aguard. transferência" />
                        <DropdownItem value="return_route" text="Rota devolução" />
                        <DropdownItem value="returned" text="Devolvido" />
                        <DropdownItem value="collected_not_received" text="Coletados Não Receb." />
                        <DropdownItem value="cancelled_after_received" text="Canc. após Receb." />
                        <DropdownItem className='DropTransOption' value="returned_area_not_serviced" text="Devolvido - Área não atendida" />
                        <DropdownItem className='DropTransOption' value="new_driver_allocated" text="Novo entregador alocado" />
                    </Dropdown>
                  </Col>
                  {selectedSource !== "mazelog" ? (
                    <Col numColSpan={1}>
                      {selectedSource === "mercado_livre" && (
                        <>
                            <Title>Status Canal</Title>
                            <Dropdown
                              className="max-w-md"
                              value={statusChannel}
                              onValueChange={(value) => setStatusChannel(value)}
                            >
                              <DropdownItem value="all" text="Todos os status" className="border-b mb-2" />
                              <DropdownItem value="pending" text="Pendente" />
                              <DropdownItem value="handling" text="Manuseio" />
                              <DropdownItem value="ready_to_ship" text="Pronto para envio" />
                              <DropdownItem value="shipped" text="Enviado" />
                              <DropdownItem value="shipped|bad_address" text="Endereço incorreto" />
                              <DropdownItem value="shipped|receiver_absent" text="Destinatário ausente" />
                              <DropdownItem value="delivered" text="Entregue" />
                              <DropdownItem value="not_delivered" text="Não entregue" />
                              <DropdownItem value="cancelled" text="Cancelado" />
                            </Dropdown>
                        </>
                          )}

                          {selectedSource === "shopee" && (
                            <>
                              <Title>Status Canal</Title>
                              <Dropdown
                                className="max-w-md"
                                value={statusChannel}
                                onValueChange={(value) => setStatusChannel(value)}
                              >
                                <DropdownItem value="all" text="Todos os status" className="border-b mb-2" />
                                <DropdownItem value="LOGISTICS_NOT_STARTED" text="Logística não iniciada" />
                                <DropdownItem value="LOGISTICS_REQUEST_CREATED" text="Envio solicitado" />
                                <DropdownItem value="LOGISTICS_PICKUP_DONE" text="Coletado pela transportadora" />
                                <DropdownItem value="LOGISTICS_PICKUP_RETRY" text="Reagendamento de coleta" />
                                <DropdownItem value="LOGISTICS_PICKUP_FAILED" text="Coleta falhou ou não prosseguiu" />
                                <DropdownItem value="LOGISTICS_DELIVERY_DONE" text="Entregue com sucesso" />
                                <DropdownItem value="LOGISTICS_DELIVERY_FAILED" text="Entrega falhou" />
                                <DropdownItem value="LOGISTICS_REQUEST_CANCELED" text="Envio cancelado" />
                                <DropdownItem value="LOGISTICS_COD_REJECTED" text="Pedido rejeitado (pagamento na entrega)" />
                                <DropdownItem value="LOGISTICS_READY" text="Pronto para envio (pagamento aprovado)" />
                                <DropdownItem value="LOGISTICS_INVALID" text="Pedido inválido/cancelado" />
                                <DropdownItem value="LOGISTICS_LOST" text="Pedido perdido pela transportadora" />
                                <DropdownItem value="LOGISTICS_PENDING_ARRANGE" text="Logística pendente de agendamento" />
                              </Dropdown>
                            </>
                          )}
                      </Col>
                    ) : (
                      <div></div>
                  )}
                  <Col numColSpan={1}>
                    <Toggle onValueChange={(value) => setFilterByDate(value)} value={filterByDate} color='purple' className='DateSwitch'>
                      <ToggleItem value='emission' text='Criação'>Hey</ToggleItem>
                      <ToggleItem value='update' text='Atualização'>Ho</ToggleItem>
                    </Toggle>
                  </Col>
                  <Col numColSpan={2}>
                    <div className='flex gap-2 mt-4'>
                      <Button className='FilterButton' onClick={() => handleFilter()}>
                        Buscar
                      </Button>
                      <Button
                        className='FilterButton'
                        onClick={() => downloadCsv()}
                        loading={fileDownloadLoading}
                      >
                        Download Excel
                      </Button>
                      { !isTransporter && !isClient && (
                        <Link to="/orders">
                          <Button className='FilterButton'>
                              Abrir etiquetas
                          </Button>
                        </Link>
                      )}
                      {!isTransporter && !isClient &&  (
                        <Button className='FilterButton' onClick={handleBatchDelete}>
                          Apagar
                        </Button>
                      )}
                    </div>
                  </Col>
                </Grid>
              <Divider/>
              {requested ? 
                <div className="flex justify-center items-center my-10">
                  <div className="spinner h-16 w-16"></div>
                </div>
              : 
                <Table>
                    <TableHead>
                        <TableRow>
                          <TableHeaderCell>
                                <input
                                    type='checkbox'
                                    checked={searchedOrders.length === selectedOrders.length}
                                    onChange={checkAllHandler}
                                    className='OrderCheckBox'
                                />
                            </TableHeaderCell>
                            <TableHeaderCell>ID do pedido</TableHeaderCell>
                            <TableHeaderCell className="text-left">Número da nota</TableHeaderCell>
                            <TableHeaderCell className="text-left">Canal</TableHeaderCell>
                            <TableHeaderCell className="text-left">Data de criação</TableHeaderCell>
                            <TableHeaderCell className="text-left">Data de atualização</TableHeaderCell>
                            <TableHeaderCell className="text-left">Status MZO</TableHeaderCell>
                            <TableHeaderCell className="text-left">Status Canal</TableHeaderCell>
                            <TableHeaderCell className="text-left">Sub Status Canal</TableHeaderCell>
                            <TableHeaderCell className="text-left">Remetente</TableHeaderCell>
                            <TableHeaderCell className="text-left">Destinatário</TableHeaderCell>
                            <TableHeaderCell className="text-left">CEP Dest</TableHeaderCell>
                            {(!isTransporter && !isClient) && (
                              <TableHeaderCell className="text-left">Transportador</TableHeaderCell>
                            )}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                      {
                        searchedOrders
                            .reduce<ShortOrder[]>((uniqueOrders, order) => {
                              const seenPackIds = new Set(uniqueOrders.map(o => o.packId));
                              
                              const seenReceiptNumbers = new Set(uniqueOrders.map(o => o.receiptNumber));

                              if (order.packId && seenPackIds.has(order.packId)) {
                                return uniqueOrders;
                              }

                              if (order.receiptNumber && seenReceiptNumbers.has(order.receiptNumber)) {
                                return uniqueOrders;
                              }

                              return [...uniqueOrders, order];
                            }, [])
                            .map((order) => {
                              let statusChannel = "-"
                              let subStatusChannel = "-"
                              let creationDate = convertDate(order.creationDate.toString())

                              if (order.source === OrderSources.MERCADO_LIVRE) {
                                statusChannel = statusChannelTranslate[order.meliLastStatus?.status ?? ""]
                                subStatusChannel =  meliSubStatusTranslate[order.meliLastStatus?.substatus ?? ""]
                              }
                              else if (order.source === OrderSources.SHOPEE) {
                                const latest = [...(order.shopee_data_status?.response.tracking_info || [])].sort((a, b) => b.update_time - a.update_time)[0];
                                subStatusChannel = statusChannelTranslate[latest?.logistics_status ?? ""];
                                statusChannel  = shopeeLogisticStatusTranslate[order.shopee_data_status?.response.logistics_status ?? ""]
                                creationDate = convertDateBr(order.creationDate.toString())
                              }

                              return (
                                <TableRow key={ order.orderNumber }>
                                  <TableCell className="TableField">
                                      <input
                                          type='checkbox'
                                          checked={selectedOrders.includes(order.orderNumber)}
                                          onChange={() => checkOneHandler(order.orderNumber)}
                                      />
                                  </TableCell>
                                  <TableCell className="TableField">
                                    <Link to={`/order/${order.orderNumber}`}>
                                      <u>{ order.orderNumber }</u>
                                    </Link>
                                  </TableCell>
                                  <TableCell
                                    className="TableField max-w-[250px] whitespace-normal truncate"
                                    title={order.packId ?? order.receiptNumber}
                                  >
                                    {order.packId ?? order.receiptNumber}
                                  </TableCell>
                                  <TableCell className="TableField">{ order.source }</TableCell>
                                  <TableCell className="TableField text-center">{ creationDate }</TableCell>
                                  <TableCell className="TableField text-center">{ convertDate(order.lastStatusDate.toString()) }</TableCell>
                                  <TableCell className="TableField">{ statusTranslate[order.status] }</TableCell>
                                  <TableCell className="TableField">{ statusChannel }</TableCell>
                                  <TableCell className="TableField">{ subStatusChannel }</TableCell>
                                  <TableCell className="TableField" title={order.sender}>{ truncateString(order.sender, 20) }</TableCell>
                                  <TableCell className="TableField" title={order.receiver}>{ truncateString(order.receiver, 25) }</TableCell>
                                  <TableCell className="TableField">{ order.receiverZIP }</TableCell>
                                  {(!isTransporter && !isClient) && (
                                    <TableCell className="TableField">{ order.transporter }</TableCell>
                                  )}
                                  <Link to={`/order/${order.orderNumber}`}><Button className='OpenOrderBtn' icon={ArrowUpRightIcon} /></Link>
                                </TableRow>
                              )
                            }
                            ) 
                      }
                    </TableBody>
                </Table>
              }
              {searchedOrders.length > 0 && (
                <ReactPaginate
                  pageCount={calculatePageCount()}
                  pageRangeDisplayed={5}
                  marginPagesDisplayed={2} 
                  onPageChange={({ selected }) => {
                    setPage(selected);
                    handleSubmit(selected);
                  }}  
                  forcePage={page}
                  containerClassName="pagination"
                  activeClassName="active"
                  previousLabel="Anterior"
                  nextLabel="Próxima"
                  breakLabel="..."
                  disabledClassName="disabled"
                />
              )}
            </Card>
            </div>
          ) : ("")}

          {/* Correio Component */}
          {(showCard === "1")  ? (
            <div className='w-full'>
              <CorreiosSearchComponent
                selectedOrders={selectedOrders}
                setSelectedOrders={setSelectedOrders}
              />
            </div>
          ) : ("")}

        </div>
      </div>
    </main>
  );
}